/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Tongyu's Portfolio",
  description:
    "Tongyu Hu is a law and computer science student building at the intersection of technology, legal systems, strategy and social impact.",
  og: {
    title: "Tongyu Hu",
    type: "website",
    url: "tongyuhu.com/",
  },
};

//Home Page
const greeting = {
  title: "Tongyu Hu",
  logo_name: "Tongyu Hu",
  nickname: "",
  subTitle:
    "<if happy: then success>",
  resumeLink:
    "",
  portfolio_repository: "https://github.com/tongyuuu",
  githubProfile: "https://github.com/tongyuuu",
  highlights: [],
  stats: [],
};

const socialMediaLinks = [

  {
    name: "Github",
    link: "https://github.com/tongyuuu",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/tongyu-hu-41b65b24a/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:thvisions@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/Flashboom132/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/tongyu._.hu/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Law Student",
      fileName: "DataScienceImg",
      skills: [
        "Commercial and technology law experience across Clayton Utz, ASX, Ada Evans Chambers and Axletree Law.",
        "Worked on IP disputes, technology transactions, contracts, legal research, CHESS holding information requests and internal matter management systems.",
        "Comfortable with legal research, drafting, stakeholder communication, Excel, PowerAutomate, Westlaw and LexisNexis.",
      ],
      softwareSkills: [
      ],
    },
    {
      title: "Computer Science Student",
      fileName: "FullStackImg",
      skills: [
        "Built production-facing internal tooling at Atlassian using TypeScript, React, Atlaskit and AWS workflows.",
        "Studied Python, systems programming, Java, data structures, algorithms, AI, databases and capstone computer science project work.",
        "Experience across Java, Python, C, CSS, TypeScript, React, SQL and Unity.",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "unity",
          fontAwesomeClassname: "simple-icons:unity",
          style: {
            color: "#663399",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/layman_brother/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/layman_brother",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/tongyu_1919",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/layman_brother",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@tongyu391",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/laymanbrother",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "The University of Sydney",
      subtitle: "Bachelor of Laws / Bachelor of Science (Majoring in Computer Science)",
      logo_path: "usyd_logo.png",
      alt_name: "USYD",
      duration: "Feb 2022 - Nov 2027",
      descriptions: [
        "WAM: 78 / Distinction. Dalyell Scholar and Vice Chancellor's Global Mobility Scholarship recipient.",
        "Notable results: Top 20 in LAWS1023 Public International Law; Top 10 in PHIL1012 Introductory Logic, MATH1064 Discrete Maths and COMP3888 Computer Science Project.",
        "Competitions: 1st at SYNCSHACK 2024; 2nd at SUBS x 180DC Social Impact Case Competition 2023; 3rd at BAP x McKinsey International Case Competition 2024.",
        "Additional results: Mastercard Innovation Challenge finalist, P&G PEAKathon national finalist, Corrs Senior Negotiations and Ashurst Client Interviewing quarter finalist.",
      ],
      website_link: "https://www.sydney.edu.au/",
    },
    {
      title: "Humboldt-Universitat zu Berlin",
      subtitle: "German Language, History and Politics",
      logo_path: "",
      alt_name: "Humboldt University",
      duration: "Jun 2024 - Jul 2024",
      descriptions: [
        "Grade: High Distinction, 100.",
        "Ranked 1st in course out of 60 students.",
        "Completed overseas study with support from the Vice Chancellor's Global Mobility Scholarship.",
      ],
      website_link: "https://www.hu-berlin.de/",
    },
    {
      title: "North Sydney Boys High School",
      subtitle: "High School Certificate",
      logo_path: "nsbhs.png",
      alt_name: "NSBHS",
      duration: "2016 - 2021",
      descriptions: [
        "ATAR: 99.60, top 0.4% in NSW.",
        "Studied Mathematics Advanced, Extension 1 and Extension 2, English Advanced, Chemistry and Software Design.",
        "Distinguished Achiever, All Rounder, Peer Support Leader, tennis representative and Department of Education Volunteering Bronze Award recipient.",
      ],
      website_link: "https://northsydbo-h.schools.nsw.gov.au/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Level 1 and 2 - Sailing",
      subtitle: "Royal Yachting Association (RYA)",
      logo_path: "usyd_logo2.png",
      certificate_link:
        "https://www.rya.org.uk/",
      alt_name: "RYA",
      color_code: "#0B2740",
    },
    {
      title: "RYA/RCG Competency",
      subtitle: "NSW Government",
      logo_path: "nswCusService.png",
      certificate_link:
        "https://www.service.nsw.gov.au/",
      alt_name: "NSW Government",
      color_code: "#F4F7FB",
    },
    {
      title: "Barista",
      subtitle: "Cotti Coffee",
      logo_path: "contactMail.png",
      certificate_link:
        "https://www.cotticoffee.com/",
      alt_name: "Cotti Coffee",
      color_code: "#C90032",
    },
    {
      title: "Ahead at Ashurst",
      subtitle: "Ashurst",
      logo_path: "ashurst.png",
      certificate_link:
        "https://www.ashurst.com/",
      alt_name: "ashurst",
      color_code: "#8C151599",
    },
    {
      title: "Digital Law: Virtual Internship",
      subtitle: "Herbert Smith Freehills",
      logo_path: "hsf.webp",
      certificate_link:
        "https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/Herbert%20Smith%20Freehills/tkyHgkGXivwRekau5_Herbert%20Smith%20Freehills_kn8r4jqmJeeNAuRga_1673756482662_completion_certificate.pdf",
      alt_name: "freehills",
      color_code: "#ECECEC",
    },
    {
      title: "CU Up Close",
      subtitle: "Clayton Utz",
      logo_path: "clayton.png",
      certificate_link:
        "https://www.claytonutz.com/",
      alt_name: "Clayton",
      color_code: "#0C9D5899",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internships and Societies\n",
  description:
    "A blend of legal, product, engineering and student leadership work across commercial law, capital markets, cloud infrastructure and social impact.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Summer Clerk",
          company: "Clayton Utz",
          company_url: "https://www.claytonutz.com/",
          logo_path: "clayton.png",
          duration: "November 2025 - February 2026",
          location: "Sydney, NSW",
          description:
            "Rotated through Intellectual Property Disputes and Technology Corporate. Drafted 50+ copyright infringement responses, conducted business development research into AFR Fast 100 start-ups, completed IP due diligence across 30+ contracts for VSE's $2.025B acquisition of Precision Aviation Group, and supported contract drafting and pro-bono legal work.",
          color: "#0C9D58",
        },
        {
          title: "Paralegal",
          company: "Australian Securities Exchange",
          company_url: "https://www.asx.com.au/",
          logo_path: "asx.png",
          duration: "February 2024 - November 2025",
          location: "Sydney, NSW",
          description:
            "Serviced 200+ requests for information from ASIC, RBA, liquidators and bankruptcy trustees; maintained 50+ trademark registrations; researched the Corporations Act and ASX Rulebooks; and built Excel-based legal matter management and cyber incident response tools for internal legal teams.",
          color: "#0879bf",
        },
        {
          title: "Paralegal",
          company: "Ada Evans Chambers",
          company_url: "https://www.adaevanschambers.com",
          logo_path: "ada.png",
          duration: "February 2023 - May 2023",
          location: "Sydney, NSW",
          description:
            "Worked under Barrister John Degreenlaw in aiding his legal matters, involving WID (Work Injury Damages), MVA (Motor Vehicle Accidents), HSAC (Historical Sexual Abuse Cases) by drafting Statements of Claim, writing Chronologies and performing Legal Research.",
          color: "#9b1578",
        },
        {
          title: "Paralegal",
          company: "Axletree Law",
          company_url: "https://axletreelaw.com/",
          logo_path: "axletree.png",
          duration: "August 2022 - May 2023",
          location: "Surry Hills, NSW",
          description:
            "Helped in creation of company website alongside legal research tasks. Further aided in drafting of contracts, research into smart contracts and how to secure web browsers themselves.",
          color: "#fc1f20",
        },
        {
          title: "Academic Tutor",
          company: "Reach Academy",
          company_url: "https://reachacademy.com.au/",
          logo_path: "reach.png",
          duration: "April 2022 - February 2023",
          location: "Castle Hill, NSW",
          description:
            "Tutored students in both private 1-1 sessions as well as in groups for a wide variety of subjects (Maths, English, Chemistry, Software) making sure that they understood the content. Further provided personalised feedback and marking as well as individualised questions for them to excel in their exams.",
          color: "#fc1f20",
        }
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Software Engineering Intern",
          company: "Atlassian",
          company_url: "https://www.atlassian.com/",
          logo_path: "atlassianv2.png",
          duration: "November 2023 - February 2024",
          location: "Sydney, NSW",
          description:
            "Built an AWS Account Request Form from scratch using TypeScript, React and Atlaskit for the Cloud Engineering System, servicing around 80% of company teams. Created internal testing guides and Confluence documentation that saved engineers 5+ hours of framework research.",
          color: "#000000",
        },
      ],
    },
    {
      title: "Societies",
      experiences: [
        {
          title: "Engagement Director",
          company: "BusinessOne Consulting University of Sydney",
          company_url: "https://www.microsoft.com/",
          logo_path: "businessOne.png",
          duration: "March 2023 - November 2024",
          location: "University of Sydney",
          description:
            "Led a team of six consultants to develop a marketing strategy and UX/UI redesign for Archistar AI, an AFR Fast 100 proptech company. Also developed an investor acquisition strategy for Bloom Impact Investing, an impact-focused managed fund with $1.7m funds under management.",
          color: "#D83B01",
        },
        {
          title: "Vice President",
          company: "University of Sydney Chocolate Society",
          company_url: "https://au.linkedin.com/company/university-of-sydney-chocolate-society",
          logo_path: "chocsoc.png",
          duration: "September 2022 - October 2023",
          location: "University of Sydney",
          description:
            "Managing the society and assisting with the organisation of weekly events which ranged from trivia nights to distribution of various foods such as blackstar pastry. Further had a role in securing external partnerships, which involved contacting Strike Bowling, Sharetea, etc...",
          color: "#4285F4",
        },
        {
          title: "Vice President of Sponsorships",
          company: "Sydney University Impact Investing Society",
          company_url: "https://www.suiis.com.au/",
          logo_path: "suiis.png",
          duration: "September 2023 - October 2025",
          location: "University of Sydney",
          description:
            "Liaised with and onboarded 10+ sponsors including Macquarie Capital and Australian Ethical. Led industry sponsors including Corrs Chambers Westgarth and Allegro Funds to host the society's largest private equity event, with 100+ attendees.",
          color: "#000000",
        },
        {
          title: "Treasurer",
          company: "USYD Comm-Stem Society",
          company_url: "https://www.usydcommstem.org/",
          logo_path: "commstem.png",
          duration: "April 2024 - October 2025",
          location: "University of Sydney",
          description:
            "Managed society funds, reimbursements and student grants, supporting large-scale events including a university cruise for 300+ people as well as career, AI and industry networking events.",
          color: "#181717",
        },
        {
          title: "Science and Law Mentor",
          company: "University of Sydney",
          company_url:
            "https://www.sydney.edu.au/",
          logo_path: "usyd.png",
          duration: "January 2023 - Present",
          location: "Sydney, Australia",
          description:
            "Mentored two groups of first year Science and Law students, leading weekly sessions which involved disseminating information about how to navigate the first semester of univeristy. Further provided advice on study habits and also societies to join to make the most of University life",
          color: "#0C9D58",
        },
        {
          title: "Industry Subcommittee",
          company: "Sydney University Computing Society",
          company_url: "https://syncs.org.au/",
          logo_path: "syncs.png",
          duration: "March 2023 - September 2023",
          location: "University of Sydney",
          description:
            "As an industry liaison, I was responsible for contacting a wide variety of sponsors/partners, bringing on new sponsors as well as liaising with them to organise company participation at student run events at the Univeristy. Some notable events included site tours at Atlassian, Quantium and FDM Group",
          color: "#181717",
        },
        {
          title: "Careers Guide Editor",
          company: "Sydney University Law Society",
          company_url: "https://www.suls.org.au/",
          logo_path: "suls.png",
          duration: "January 2023 - March 2023",
          location: "University of Sydney",
          description:
            "Worked on the careers guide for 2023, contacting various international law firms to update their relevant brochures and information about their firm. Furthermore summarised and analysed different law firms to create a handbook of information for students to read and understand future career opportunities.",
          color: "#181717",
        },
        {
          title: "Emergency Services Volunteer",
          company: "Australian Red Cross",
          company_url: "https://www.redcross.org.au/",
          logo_path: "red_cross.png",
          duration: "December 2022 - November 2023",
          location: "Sydney NSW",
          description:
            "Worked as an emergency services volunteer where I helped to provide Psychological First Aid to victims of natural disasters. Further attended and helped run safety talks at relevant community centres to promote awareness and safety amongst the community.",
          color: "#181717",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My Projects encompass a wide range of languages and skillsets, ranging from 3D Multiplayer games to the creation of a Virtual Machine in the RISKXVIII Architecture. These have allowed me to excel in quickly learning new languages as well as building core fundamental coding skills. See the below for the projects that I have completed.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "neuro-symbolic-sudoku-solver",
      name: "Neuro-Symbolic Sudoku Solver",
      createdAt: "2023-07-02T00:00:00Z",
      description: "Paper published in KDD KiML 2023",
      url: "https://arxiv.org/abs/2307.00653",
    },
    {
      id: "SULS 2023",
      name: "MDP-Diffusion",
      createdAt: "2023-09-19T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/mdp-diffusion/",
    },
    {
      id: "consistency-models",
      name: "Consistency Models",
      createdAt: "2023-10-12T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/consistency-models/",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Let's connect",
    profile_image_path: "tongyu-headshot.jpg",
    description:
      "I am always happy to chat about legal technology, product work, student leadership, consulting projects or interesting ideas at the edge of law and computer science.",
  },
  blogSection: {
    title: "LinkedIn",
    subtitle:
      "The best place to see my current roles and updates.",
    link: "https://www.linkedin.com/in/tongyu-hu-41b65b24a/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Sydney NSW, 2000, Australia",
    locality: "Sydney",
    country: "Australia",
    region: "NSW",
    postalCode: "2153",
    streetAddress: "Sydney",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://www.google.com/maps/place/Sydney+NSW/data=!4m2!3m1!1s0x6b129838f39a743f:0x3017d681632a850?sa=X&ved=1t:242&ictx=111",
  },
  phoneSection: {
    title: "Email",
    subtitle: "tongyu.hu124@gmail.com",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
